import { defineMessages } from 'react-intl';

export const sidebarMessages = defineMessages({
  toggleSidebar: {
    defaultMessage: 'Toggle Sidebar',
    id: 'r+l8IsJXtT',
    description: 'Accessible label for the page shell sidebar toggle button',
  },
});
